import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CloudConstants} from '../../constants/cloud.constants';
import {DatabaseConstants} from '../../constants/database.constants';
import {CreateDatabaseDuringSignUpComponent, EditDatabaseDuringSignUpComponent} from '../signup.component';
import {MatDialog} from '@angular/material';
import {CloudConfigsComponent} from './cloud-configs/cloud-configs.component';
import {ApiGatewayConstants} from '../../constants/apigateway.constants';
import {AddApiGatewayComponent} from '../../settings/api-gateway-settings/add-api-gateway/add-api-gateway.component';
import {FilestorageConstants} from '../../constants/filestorage.constants';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'signup-configurations',
  templateUrl: './signup-configurations.component.html',
  styleUrls: ['./signup-configurations.component.scss']
})
export class SignupConfigurationsComponent implements OnInit {

  logo = './assets/img/partnerOnboarding/build.png';

  steps = [
    {
      stepNo: 1,
      name: 'cloud',
      title: 'Cloud Platform',
      subtitle: 'Setup cloud',
      mainTitle: 'Choose Cloud Platform(s)',
      skippable: false,
      mainDescription: 'Choose one or more cloud platform(s) to start running your APIs from the options below:',
      note: 'You can modify your choice(s) at any time after the setup process'
    },
    {
      stepNo: 2,
      title: 'Configuration Database',
      name: 'configdb',
      subtitle: 'Setup API Gateway',
      mainTitle: 'Choose Configuration Database',
      skippable: false,
      mainDescription: 'apiplatform.io currently supports MongoDB for its configuration databases. You can choose to switch from apiplatform.io’s database to your own MongoDB database and vice versa.',
      note: 'The database you choose must be a MongoDB database for your application to function properly.',
    },
    {
      stepNo: 3,
      name: 'apigateway',
      title: 'API Gateway',
      subtitle: 'Setup API Gateway',
      mainTitle: 'Configure Your API Gateway',
      skippable: false,
      mainDescription: 'Choose one or more API gateway(s) from the options below to act as the entry point for your APIs.',
      note: 'You can modify your choice(s) at any time after the setup process'
    },
    {
      stepNo: 4,
      title: 'Application Database',
      name: 'databases',
      subtitle: 'Setup API Gateway',
      mainTitle: 'Configure Application Database',
      skippable: true,
      mainDescription: 'Choose a database offered by apiplatform.io or connect an external database of your choice.',
      note: 'It is possible to include additional database configurations at any point after the setup process.'
    },
    {
      stepNo: 5,
      name: 'filestorage',
      title: 'File Storage',
      mainTitle: 'Configure File Storage Provider',
      skippable: false,
      mainDescription: 'Use apiplatform.io’s S3 bucket or connect your own S3 bucket storage.',
      note: 'apiplatform.io currently supports S3 buckets for file storage.'
    },
  ];

  @Output() clickedProceed: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickedBackButton: EventEmitter<any> = new EventEmitter<any>();

  currentStep = 0;
  currentStepName = 'cloud';

  cloudProvider = 'apiplatform';
  cloudInfras = CloudConstants.cloudInfraList;
  externalCloudInfras = CloudConstants.externalCloudInfraList;

  gatewayProvider = 'apiplatform';
  gatewayProviders = ApiGatewayConstants.internalGatewayTypes;
  externalGatewayProviders = ApiGatewayConstants.externalGatewayTypes;

  databaseProvider = 'apiplatform';
  externalDatabaseConnectionData: any;
  databaseTypes = DatabaseConstants.databaseTypes;
  externalDatabasetype: any;

  configdbProvider = 'apiplatform';
  externalConfigdbData: any;
  externalConfigDatabasetype: any;

  fileStorageProvider = 'apiplatform';
  fileStorageTypes = FilestorageConstants.fileStorageProviders;

  constructor(private dialog: MatDialog,
              private platform: LeftpanelComponent) { }

  ngOnInit() {
  }

  prevStep() {
    this.currentStep = this.currentStep - 1;
    this.currentStepName = this.steps[this.currentStep].name;
  }

  nextStep() {
    if (this.steps[this.currentStep].name === 'cloud') {
      if (this.isCloudValid()) {
        this.currentStep = this.currentStep + 1;
        this.currentStepName = this.steps[this.currentStep].name;
      } else {
        this.platform.openSnackBar('Please select at least one cloud provider.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else if (this.steps[this.currentStep].name === 'apigateway') {
      if (this.isApiGatewayValid()) {
        this.currentStep = this.currentStep + 1;
        this.currentStepName = this.steps[this.currentStep].name;
      } else {
        this.platform.openSnackBar('Please select at least one API gateway.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else if (this.steps[this.currentStep].name === 'configdb') {
      if (this.isConfigDbValid()) {
        this.currentStep = this.currentStep + 1;
        this.currentStepName = this.steps[this.currentStep].name;
      } else {
        this.platform.openSnackBar('Please select the configuration database for your partner account.', 'Error', {
          duration: 4000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    } else {
      this.currentStep = this.currentStep + 1;
      this.currentStepName = this.steps[this.currentStep].name;
    }
  }

  skipStep() {
    this.currentStep = this.currentStep + 1;
    this.currentStepName = this.steps[this.currentStep].name;
  }

  databaseChanged(index, changeValue = false) {
    this.databaseTypes.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  internalProviderChanged(index, changeValue = false) {
    this.gatewayProviders.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  externalProviderChanged(index, changeValue = false) {
    this.externalGatewayProviders.forEach((database, i) => {
      if (!database.disabled) {
        if (i !== index) {
          database.selected = false;
        } else {
          if (changeValue) {
            database.selected = !database.selected;
          }
        }
      } else {
        database.selected = false;
      }
    });
  }

  createExternalDatabase() {
    if (!this.externalDatabaseConnectionData) {
      const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
        disableClose: true,
        width: '50%',
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.externalDatabaseConnectionData = result;
          this.externalDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);
        } else {
          this.databaseProvider = 'apiplatform';
        }
      });
    }
  }

  createExternalConfigDatabase() {
    if (!this.externalConfigdbData) {
      const dialogRef = this.dialog.open(CreateDatabaseDuringSignUpComponent, {
        disableClose: true,
        width: '50%',
        data: {
          disableDbTypeSelector: true,
          disableDbNameInput: true,
          partner: 'hari',
          account: 'hari',
          isConfigDb: true,
          configType: 'external'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.externalConfigdbData = result;
          this.externalConfigDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);

        } else {
          this.configdbProvider = 'apiplatform';
        }
      });
    } else {
      const dialogRef = this.dialog.open(EditDatabaseDuringSignUpComponent, {
        disableClose: true,
        width: '50%',
        data: {
          config: this.externalConfigdbData,
          isConfigDb: true,
          database_type: 'mongodb'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.externalConfigdbData = result;
          this.externalConfigDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);
        }
      });
    }
  }

  editExternalDatabase() {
    const dialogRef = this.dialog.open(EditDatabaseDuringSignUpComponent, {
      disableClose: true,
      width: '50%',
      data: [this.externalDatabaseConnectionData]
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.externalDatabaseConnectionData = result;
        this.externalDatabasetype = this.databaseTypes.find(databaseType => databaseType.value === result.database_type);
      }
    });
  }

  addExternalGateway(gateway, checked) {
    if (checked) {
      const dialogRef = this.dialog.open(AddApiGatewayComponent, {
        disableClose: true,
        width: '50%',
        data: {
          apigateway: gateway.externalConfig,
          isEdit: gateway.externalConfig !== null,
          disableGatewayTypeSelector: true,
          disableGatewayNameInput: true,
          gatewayType: gateway.value,
          returnWithoutCreate: true
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          gateway['externalConfig'] = result;
        } else {
          if (!gateway.externalConfig) {
            gateway['selected'] = false;
          }
        }
      });
    }
  }

  addExternalCloud(cloud, checked) {
    if (checked) {
      const dialogRef = this.dialog.open(CloudConfigsComponent, {
        disableClose: true,
        width: '50%',
        data: {
          cloudConfig: cloud,
          config: cloud.externalConfig,
          isEdit: cloud.externalConfig
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          cloud['externalConfig'] = result;
        } else {
          if (!cloud.externalConfig) {
            cloud['selected'] = false;
          }
        }
      });
    }
  }

  isCloudValid() {
    if (this.cloudProvider === 'apiplatform') {
      const selectedClouds = this.cloudInfras.filter(cloud => cloud.selected);
      return selectedClouds.length > 0;
    } else {
      const selectedClouds = this.externalCloudInfras.filter(cloud => cloud.selected);
      if (selectedClouds.length > 0) {
        const hasExternalConfigWithHost = selectedClouds.every(cloud => {
          return cloud && cloud['externalConfig'] && typeof cloud['externalConfig'] === 'object' && cloud['externalConfig'].host;
        });

        return hasExternalConfigWithHost;
      } else {
        return false;
      }
    }
  }

  getCloudInput() {
    const selectedClouds = this.cloudProvider === 'apiplatform' ?
        this.cloudInfras.filter(cloud => cloud.selected) :
        this.externalCloudInfras.filter(cloud => cloud.selected);

    const request = selectedClouds.map(cloud => ({
      cloud: cloud.value,
      provider: cloud.provider
    }));

    return request;
  }


  // has to be updated when external config DB comes in place
  isConfigDbValid() {
    return this.cloudProvider === 'apiplatform';
  }

  getApiGatewayInput() {
    let request = [];

    if (this.gatewayProvider === 'apiplatform') {
      request.push({
        cloud: 'aws',
        provider: 'apiplatform'
      });
    } else {
      const selectedGateways = this.externalGatewayProviders.filter(gateway => gateway.selected);
      request = selectedGateways.map(cloud => ({
        type: cloud.value,
        provider: cloud.provider,
        config: cloud['externalConfig']
      }));
      if (request.length === 1) {
        request[0].config['name'] = 'default';
      }
    }

    return request;
  }

  getConfigDbInput() {
    if (this.configdbProvider === 'apiplatform') {
      return {
        provider: 'apiplatform'
      };
    } else {
      const dbPayload = JSON.parse(JSON.stringify(this.externalConfigdbData));
      dbPayload['provider'] = 'external';
      return dbPayload;
    }
  }

  getDatabaseInput() {
    const request = [];

    if (this.databaseProvider === 'apiplatform') {
      const selectedDatabase = this.databaseTypes.filter(db => db.selected);
      if (selectedDatabase.length === 1) {
        request.push({
          connection_type: 'apiplatform',
          connection_name: 'default',
          database_type: selectedDatabase[0].value,
          type: 'apiplatform'
        });
      }
    } else {
      if (this.externalDatabaseConnectionData) {
        this.externalDatabaseConnectionData['type'] = 'external';
      }
      request.push(this.externalDatabaseConnectionData);
    }
    return request;
  }

  getFileStorageInput() {
    const request = [];
    if (this.fileStorageProvider === 'apiplatform') {
      const selectedFiles = this.fileStorageTypes.filter(f => f.selected);
      if (selectedFiles.length > 0) {
        request.push({
          cloud: 'aws',
          provider: 'apiplatform'
        });
      }
    }
    return request;
  }

  isApiGatewayValid() {
    if (this.gatewayProvider === 'apiplatform') {
      const selectedGateway = this.gatewayProviders.filter(cloud => cloud.selected);
      return selectedGateway.length > 0;
    } else {
      const selectedGateway = this.externalGatewayProviders.filter(cloud => cloud.selected);
      if (selectedGateway.length > 0) {
        const hasExternalConfig = selectedGateway.every(cloud => {
          return cloud && cloud['externalConfig'] && typeof cloud['externalConfig'] === 'object';
        });

        return hasExternalConfig;
      } else {
        return false;
      }
    }
  }

  proceed() {
    this.clickedProceed.emit(this.getPartnerInput());
  }

  getPartnerInput() {
    if (this.isCloudValid() && this.isConfigDbValid() && this.isApiGatewayValid()) {
      return {
        devex: [{
          cloud: 'aws',
          provider: 'apiplatform',
        }],
        dashboard: [{
          cloud: 'aws',
          provider: 'apiplatform'
        }],
        apigateway: this.getApiGatewayInput(),
        storage: this.getFileStorageInput(),
        databases: this.getDatabaseInput(),
        configDb: this.getConfigDbInput()
      };
    } else {
      this.platform.openSnackBar('Please fill all the required information.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      return null;
    }
  }

  cancelCustomInstallation() {
    // if (confirm('Are you sure you want to go back? This will undo all of your configurations for the custom installation')) {
    //   this.clickedBackButton.emit(true);
    // }
    this.clickedBackButton.emit(true);
  }
}
